import WorkIm from '../assets/WorkIm.jpeg'
import Stopwatch from '../assets/stopwatch.jpg'



export const data=[
    {
        id:1,
        name:"React JS Application",
        image:WorkIm,
        github:"https://github.com/zappple/Monsters-Rolodex",
        live:"https://645b7e2b69fa120f8ab884c7--endearing-pie-edc9d3.netlify.app/",
    },

   
    {
        id:2,
        name:"HTM/CSS & JS Application",
        image:Stopwatch,
        github:"https://github.com/zappple/Stopwatch",
        live:"https://master--hilarious-mooncake-032334.netlify.app/",
    }
]